<template>
    <div>
        <section>
            <div class="container pt-lg-md">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <h4>
                            Как сделать компьютерный инженерный анализ доступным для
                            конструкторов? Узнайте на нашем вебинаре!
                        </h4>
						<div v-show="isAuth === false">
							<video src="https://cadflo.ru/video/1_preview/1_preview.mp4" poster="https://cadflo.ru/video/1_preview/1.png" width="100%" controls>
								Sorry, your browser doesn't support embedded videos,
								but don't worry, you can <a href="videofile.ogg">download it</a>
								and watch it with your favorite video player!
							</video><br>
							<h4><b>Для просмотра вебинара полностью Авторизуйтесь или Зарегистрируйтесь</b></h4>
						</div>			
                        <p class="heading  text-default">Запись вебинара | 20 минут</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped overflow-hidden pt-4 my-2" v-show="isAuth === false">
            <div class="shape shape-style-3 bg-default"></div>
            <div class="container pt-2">
                <div class="row justify-content-center">
                    <h5 class="text-white">Авторизуйтесь для просмотра вебинара</h5>
                </div>
                <div class="row justify-content-center mt-2">
                    <div class="col-lg-5">
                        <card type="secondary" shadow
                              header-classes="bg-white pb-5"
                              body-classes="px-lg-5 py-lg-5"
                              class="border-0">
                            <template>
                                <div class="text-center text-muted mb-4">
                                    <small></small>
                                </div>
                                <form role="form">
                                    <base-input alternative
                                                class="mb-3"
                                                placeholder="Login"
                                                addon-left-icon="ni ni-single-02"
                                                v-model="form.name" :valid="validationName">
                                    </base-input>
                                    <base-input alternative
                                                type="password"
                                                placeholder="Password"
                                                addon-left-icon="ni ni-lock-circle-open"
                                                v-model="form.pass" :valid="validationPass">
                                    </base-input>
                                    <p class="text-warning" v-show="errorAuth">Неверный пароль</p>
                                    <div class="text-center">
                                        <base-button type="default" class="my-4" @click="signIn">Войти</base-button>
                                    </div>
                                </form>
                            </template>
                        </card>
                        <div class="row mt-3">
                            <div class="col-6">
                                <a href="#" class="text-light">
                                    <small></small>
                                </a>
                            </div>
                            <div class="col-6 text-right">
                                <a class="text-light" @click="modals.sendApply = true" style="cursor:pointer">
                                    <small>Зарегистрироваться</small>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="mt-5">
            <div class="container">
                <div class="row justify-content-center mb-5" v-show="isAuth">
                    <div class="player col-lg-12">
                        <!--Как Siemens Digital Industries Software делает компьютерный инженерный анализ доступным для конструкторов Геннадий Новаковский-->
                        <video-player ref="videoPlayer"
                                      class="vjs-custom-skin"
                                      :options="playerOptions"
                                      @play="onPlayerPlay($event)"
                                      @ready="onPlayerReady($event)">
                        </video-player>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <p>
                            Вы современная производственная компания. Вы работаете в условиях высокой
                            конкуренции. Вы вынуждены сокращать проектные бюджеты и время выхода изделия на рынок.
                            Вам необходимо постоянно улучшать качество и делать продукт более инновационным.
                        </p>
                        <p>
                            Для соответствия заявленному статусу, требуется применение компьютерных инженерных
                            расчетов (CAE), сокращать число прототипов и испытаний.
                        </p>
                        <p>
                            Siemens в разработке своих CAE-решений использует идею демократизации - выполнение
                            инженерных расчетов самими конструкторами. Благодаря встроенным в CAD-систему доступных
                            CAE-технологий от Siemens, конструкторы легко осваивают дисциплину инженерных расчетов.
                            Решения позволяют им выходить на новый уровень сложности и точности моделирования. Быстро
                            находить оптимальные конструктивные решения. Снижать нагрузку на расчётчиков.
                        </p>
                        <p>
                            <b style="font-weight:600">
                                Зарегистрируйтесь и узнайте благодаря чему решения Siemens стали доступными для
                                конструкторов. Какие технологии помогают сокращать длительность и стоимость разработки
                                изделий. Как повысить продуктивность инженерных подразделений на вашем предприятии.
                            </b>
                        </p>
                        <p class="text-danger">
                            Также в подтверждении регистрации на вебинар мы отправим вам ссылку на бесплатную
                            триальную версию продукта Simcenter FloEFD, чтобы вы смогли попробовать в нем поработать.
                            Пробная версия будет доступна в течение 30 дней.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <modal :show.sync="modals.sendApply"
               body-classes="p-0"
               modal-classes="modal-dialog-centered">
            <card type="secondary" shadow
                  header-classes="bg-white pb-5"
                  body-classes="px-lg-5 py-lg-5"
                  class="border-0">
                <template>
                    <div class="text-muted text-center mb-3">
                        {{ modals.title }}
                    </div>

                </template>
                <template>
                    <div class="text-center text-muted mb-4">
                        <!--<small>Or sign in with credentials</small>-->
                    </div>
                    <form role="form" id="modalForm">
                        <base-input class="mt-3"
                                    alternative
                                    placeholder="Название предприятия"
                                    addon-left-icon="fa fa-building-o"
                                    :valid="formReg.validationCompany"
                                    v-model="formReg.company"
                                    @keydown.space.prevent>
                        </base-input>
                        <div class="form-row m-0">
                            <base-input alternative
                                        placeholder="Фамилия"
                                        addon-left-icon="ni ni-single-02"
                                        v-model="formReg.lastName" :valid="formReg.validationLast"
                                        @keydown.space.prevent
                                        class="col p-0 mr-1">
                            </base-input>
                            <base-input alternative
                                        placeholder="Имя"
                                        addon-left-icon="ni ni-single-02"
                                        v-model="formReg.name" :valid="formReg.validationName"
                                        @keydown.space.prevent
                                        class="col p-0 ml-1">
                            </base-input>
                        </div>
                        <div class="form-row m-0">
                            <base-input alternative
                                        placeholder="Телефон"
                                        :valid="formReg.validationPhone"
                                        v-model="formReg.phone"
                                        addon-left-icon="fa fa-phone"
                                        @keydown.space.prevent
                                        class="col p-0 mr-1">
                            </base-input>
                            <base-input alternative
                                        placeholder="Email"
                                        :valid="formReg.validationEmail"
                                        v-model="formReg.email"
                                        addon-left-icon="ni ni-email-83"
                                        @keydown.space.prevent
                                        class="col p-0 ml-1">
                            </base-input>
                        </div>
                        <p class="text-warning" v-show="errorReg">Ошибка при регистрации</p>
                        <base-button type="default" round block
                                     @click="reg()">
                            Зарегистрироваться
                        </base-button>
                    </form>
                </template>
            </card>
        </modal>

    </div>
</template>

<script>
    import VideoPlayer from '@/components/VideoPlayer.vue'
    import Modal from "@/components/Modal.vue"
    export default {
        name: 'home',
        components: {
            VideoPlayer,
            Modal
        },
        data() {
            return {
                playerOptions: {
                    autoplay: false,
                    controls: true,
                    controlBar: {
                        timeDivider: false,
                        durationDisplay: false
                    },
                },
                isAuth: false,
                errorAuth: false,
                errorReg: false,
                form: {
                    name: '',
                    pass: '',
                },
                validationName: null,
                validationPass: null,
                modals: {
                    sendApply: false,
                    title: '',
                    info: ''
                },
                formReg: {
                    company: '',
                    name: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    validationCompany: null,
                    validationName: null,
                    validationLast: null,
                    validationEmail: null,
                    validationPhone: null,
                },
            }
        },
        computed: {
            player() {
                return this.$refs.videoPlayer.player
            }
        },
        methods: {
            onPlayerPlay(player) {
                console.log('player play!', player)
            },
            onPlayerReady(player) {
                console.log('player ready!', player)
                //this.player.play()
            },
            playVideo: function (source) {
                const video = {
                    withCredentials: false,
                    type: 'application/x-mpegurl',
                    src: source
                }
                this.player.reset() // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
                this.player.src(video)
                this.player.load()
                //this.player.play()
            },
            signIn() {
                if (this.form.name == '') {
                    this.validationName = false;
                } else {
                    this.validationName = true;
                }
                if (this.form.pass == '') {
                    this.validationPass = false;
                } else {
                    this.validationPass = true;
                }
                if ((this.form.name != '')
                    && (this.form.pass != '')) {
                    var params = {
                        params: {
                            p: 'authorize',
                            login: this.form.name,
                            pass: this.form.pass
                        }
                    };
                    this.$axios
                        .get('/rest/auth/', params)
                        .then(response => {
                            this.isAuth = response.data.result
                            if (this.isAuth === false) {
                                this.errorAuth = true
                            } else {
                                this.$cookie.set('BITRIX_SM_LOGIN', response.data.login, 3);
                                this.$cookie.set('BITRIX_SM_PASS', response.data.pass, 3);

                                this.playVideo(response.data.src)
                            }
                        });
                }
            },
            checkAuth() {
                let login = this.$cookie.get('BITRIX_SM_LOGIN')
                let pass = this.$cookie.get('BITRIX_SM_PASS')
                var params = {
                    params: {
                        p: 'isAuth',
                        login: login,
                        pass: pass
                    }
                };
                this.$axios
                    .get('/rest/auth/', params)
                    .then(response => {
                        this.isAuth = response.data.result
                        if (this.isAuth === true) {
                            this.playVideo(response.data.src)
                        }
                    });
            },
            reg() {
                if (this.formReg.name == '') {
                    this.formReg.validationName = false;
                } else {
                    this.formReg.validationName = true;
                }
                if (this.formReg.lastName == '') {
                    this.formReg.validationLast = false;
                } else {
                    this.formReg.validationLast = true;
                }
                if (this.formReg.email == '') {
                    this.formReg.validationEmail = false;
                } else {
                    this.formReg.validationEmail = true;
                }
                if (this.formReg.phone == '') {
                    this.formReg.validationPhone = false;
                } else {
                    this.formReg.validationPhone = true;
                }
                if (this.formReg.company == '') {
                    this.formReg.validationCompany = false;
                } else {
                    this.formReg.validationCompany = true;
                }
                if ((this.formReg.name != '')
                    && (this.formReg.lastName != '')
                    && (this.formReg.email != '')
                    && (this.formReg.phone != '')
                    && (this.formReg.company != '')) {
                    var params = {
                        params: {
                            p: 'reg',
                            email: this.formReg.email,
                            name: this.formReg.name,
                            lastName: this.formReg.lastName,
                            phone: this.formReg.phone,
                            company: this.formReg.company,
                        }
                    };
                    this.$axios
                        .get('/rest/auth/', params)
                        .then(response => {
                            this.isAuth = response.data.result
                            if (this.isAuth === true) {
                                this.$cookie.set('BITRIX_SM_LOGIN', response.data.login, 3);
                                this.$cookie.set('BITRIX_SM_PASS', response.data.pass, 3);
                                this.playVideo(response.data.src)
                                this.modals.sendApply = false

                                var params = {
                                    params: {
                                        title: 'Регистрация на Вебинар',
                                        name: this.formReg.name,
                                        email: this.formReg.email,
                                        message: 'Компания: ' + this.formReg.company + '| Телефон: ' + this.formReg.phone,
                                    }
                                };
                                this.$axios
                                    .get('/rest/message/', params).then()
                            } else {
                                this.errorReg = true
                            }
                            console.log(response.data.result);
                        });
                }
            },
            async loadInfo() {
                let params_2 = new Map();
                params_2.set('entity', 'news');
                params_2.set('code', 'kak-sdelat-kompyuternyj-inzhenernyj-analiz');

                let seo = await this.$root.loadContent(params_2)
                this.$root.title = seo[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = seo[0]['SEO']['ELEMENT_META_DESCRIPTION'];
				console.log(this.$root.title);
            }
        },
        created() {
            this.checkAuth()
            this.loadInfo()
        }
    }
</script>

<style>
</style>